import React, { memo } from 'react';
import cn from 'classnames';

import { DynamicIconWrapper } from '@components/common';

import { TIconType } from '@icons/interface';

import { IValueLabelColor } from '@interfaces/common/common';

import styles from '../AlarmDetails.module.scss';

export type TAlarmFieldInfo = IValueLabelColor & {
	separator?: boolean;
	icon?: TIconType;
	handler?: () => void;
	onClick?: () => void;
};

const AlarmDetailsField = ({
	label,
	value,
	color,
	separator,
	handler,
	icon,
	onClick,
}: TAlarmFieldInfo) => {
	const containerClass = cn(styles.informationContainer, {
		[styles.detailsSeparator]: separator,
	});
	const alarmValueClass = cn(styles.info, {
		[styles.severity]: color,
		[styles.copy]: onClick,
	});

	return (
		<div className={containerClass}>
			<div className={styles.infoTitle}>{label}</div>
			<div className={styles.valueWrapper}>
				<div className={alarmValueClass}>
					{color
						? <span
							className={styles.colorCell}
							onClick={onClick}
							style={{ background: color }}
						/>
						: null
					}
					{value}
				</div>
				{handler && icon && <DynamicIconWrapper
					icon={icon}
					onClick={handler}
				/>}
			</div>
		</div>
	);
};

export default memo(AlarmDetailsField);

